import React, { useState, useEffect, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Container, Spinner, Alert, Button } from 'reactstrap';
import BreadCrumb from '../../Components/Common/BreadCrumb';
import CommonDataTable from '../../common/DataTable';
import { getCandidateResultColumns } from '../../Components/Common/columns/CandidateResult';
import { getCandidateResultWithFilterPage } from '../../slices/thunks';
import { setFilterParams } from '../../slices/candidateresult/reducer';
import { useNavigate } from 'react-router-dom';
import PopupModal from './PopupModel';

const CandidateResultList = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);
  const [selectedCandidate, setSelectedCandidate] = useState(null);

  const { candidateResults, loading, error, filterParams } = useSelector(
    (state) => state.candidateResult || {
      candidateResults: { data: { data: [], totalCount: 0, currentPage: 1, totalPages: 1 } },
      filterParams: { currentPage: 1, perPage: 20, search: '', },
    }
  );

  // Fix data structure access based on the API response
  const candidateList = candidateResults?.data?.data?.data || [];
  const totalCount = candidateResults?.data?.data?.totalCount || 0;
  const currentPage = candidateResults?.data?.data?.currentPage || 1;
  const totalPages = candidateResults?.data?.data?.totalPages || 1;

  const [selectedRows, setSelectedRows] = useState([]);
  const [confirmOpenForId, setConfirmOpenForId] = useState();

  useEffect(() => {
    const params = filterParams || { currentPage: 1, perPage: 20, search: '' };
    dispatch(getCandidateResultWithFilterPage(params));
  }, [dispatch, filterParams]);

  const fetchData = useCallback((newFilterParams) => {
    // Update filter params in Redux state
    dispatch(setFilterParams(newFilterParams));
    // Fetch new data with updated params
    dispatch(getCandidateResultWithFilterPage(newFilterParams));
  }, [dispatch]);

  const handleRowClick = (row) => {
    console.log("Clicked row ID:", row);  
    setSelectedCandidate(row);
    setShowModal(true);
  };

  const columns = getCandidateResultColumns({
    confirmOpenForId,
    setConfirmOpenForId,
    handleRowClick,
  });

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb title="Candidate Results" pageTitle="Candidate Results" />
        </Container>
      </div>

      <div className="table-container">
        {loading && (
          <div className="text-center">
            <Spinner color="primary" />
            <p>Loading candidate results...</p>
          </div>
        )}

        {error && (
          <Alert color="danger">
            <strong>Error:</strong> {error}
          </Alert>
        )}

        <PopupModal
          show={showModal}
          onClose={() => setShowModal(false)}
          data={selectedCandidate}
        />

        {!loading && !error && (
          <CommonDataTable
            from="candidateResult"
            data={candidateList}
            totalRows={totalCount}
            loading={loading}
            showAddButton={false}
            columns={columns}
            checkboxEnabled={false}
            selectedRows={selectedRows}
            bulkSelected={(rows) => setSelectedRows(rows)}
            searchEnable={true}
            filterParams={filterParams || { currentPage: 1, perPage: 20, search: '' }}
            fetchData={fetchData}
            showExportButton={false}
            exportFileName="candidateResult"
            currentPage={currentPage}
            totalPages={totalPages}
          />
        )}
      </div>
    </React.Fragment>
  );
};

export default CandidateResultList;
